import NDFL3YearLogic2019 from './NDFL3YearLogic2019';

export default class NDFL3YearLogic2020 extends NDFL3YearLogic2019 {}
